var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipelinesConvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.173747 23.9211C-0.0603719 24.1556 -0.0603719 24.5358 0.173747 24.7703C0.407866 25.0048 0.787447 25.0048 1.02157 24.7703L0.173747 23.9211ZM24.9031 0.600137C24.9031 0.26849 24.6347 -0.000363434 24.3036 -0.000363867L18.9081 -0.00036412C18.577 -0.000364457 18.3086 0.268488 18.3086 0.600137C18.3086 0.931784 18.577 1.20064 18.9081 1.20064L23.7041 1.20064L23.7041 6.00465C23.7041 6.33629 23.9725 6.60515 24.3036 6.60515C24.6347 6.60515 24.9031 6.33629 24.9031 6.00465L24.9031 0.600137ZM1.02157 24.7703L24.7275 1.02475L23.8797 0.175518L0.173747 23.9211L1.02157 24.7703Z",
    fill: "#2968C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3053 24.9557C24.6364 24.9558 24.9049 24.687 24.9049 24.3553L24.9059 18.9508C24.9059 18.6192 24.6376 18.3503 24.3065 18.3502C23.9754 18.3502 23.7069 18.619 23.7069 18.9506L23.7062 22.9054L1.02348 0.176691C0.789406 -0.0578614 0.409825 -0.0579289 0.175664 0.17654C-0.058496 0.411008 -0.0585634 0.791225 0.175514 1.02578L22.8582 23.7545L18.91 23.7538C18.5789 23.7537 18.3105 24.0225 18.3104 24.3542C18.3104 24.6858 18.5787 24.9547 18.9098 24.9548L24.3053 24.9557Z",
    fill: "#2968C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelinesConvert);
export default __webpack_public_path__ + "static/media/pipelines-convert.35785414e5e4b514b61e289f83b74c26.svg";
export { ForwardRef as ReactComponent };